import { PriceAndPlan } from '@aibees/shared/features/price-and-plan';

export function PriceAndPlanView() {
  return <PriceAndPlan />;
}
